export const checkScreenWidth = () => {
  if (window.innerWidth < 575) {
    return "mobile";
  } else return "desktop";
};
